import { CommonModule } from '@angular/common'
import { Component, inject, OnInit, signal } from '@angular/core'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { NgIconComponent, provideIcons } from '@ng-icons/core'
import {
    lucideCheckCircle2,
    lucideAlertCircle,
    lucideShieldCheck,
    lucideSparkles,
    lucideArrowLeft,
    lucideArrowRight,
} from '@ng-icons/lucide'
import { AuthApiService } from '../../auth/auth-api.service'

@Component({
    selector: 'lib-page-verify-email',
    imports: [CommonModule, RouterModule, NgIconComponent],
    providers: [
        provideIcons({
            lucideCheckCircle2,
            lucideAlertCircle,
            lucideShieldCheck,
            lucideSparkles,
            lucideArrowLeft,
            lucideArrowRight,
        }),
    ],
    templateUrl: './page-verify-email.component.html',
    styleUrls: ['./page-verify-email.component.css'],
})
export class PageVerifyEmailComponent implements OnInit {
    private authApiService = inject(AuthApiService)
    private route = inject(ActivatedRoute)

    public isLoading = signal(true)
    public isSuccess = signal(false)
    public errorMessage = signal<string | null>(null)

    ngOnInit() {
        const token = this.route.snapshot.paramMap.get('token')

        if (!token) {
            this.isLoading.set(false)
            this.errorMessage.set('Invalid verification link.')
            return
        }

        this.verifyEmail(token)
    }

    private verifyEmail(token: string) {
        this.authApiService.verifyEmail(token).subscribe({
            next: () => {
                this.isLoading.set(false)
                this.isSuccess.set(true)
            },
            error: (error) => {
                this.isLoading.set(false)
                this.isSuccess.set(false)
                const message =
                    error?.error?.message ??
                    'Verification failed. The link may be invalid or expired.'
                this.errorMessage.set(message)
            },
        })
    }
}
